import { Text } from "@react-spectrum/s2";
import AlertNoticeIcon from "@react-spectrum/s2/illustrations/linear/AlertNotice";

import {
  style,
  iconStyle,
} from "@react-spectrum/s2/style" with { type: "macro" };

export const InlineNotice = ({ errorMessage, children }) => {
  return (
    <div
      className={style({
        display: "flex",
        flexDirection: "column",
        gap: 16,
        maxWidth: 480,
        marginX: "auto",
      })}
    >
      <div
        className={style({
          display: "flex",
          alignItems: "center",
          gap: 16,
        })}
      >
        <AlertNoticeIcon
          styles={style({ size: 48 }) + iconStyle({ color: "notice" })}
        />
        <div
          className={style({
            display: "flex",
            flexDirection: "column",
            gap: 4,
          })}
        >
          {errorMessage?.map((line, index) => (
            <Text
              key={index}
              styles={style({
                font: { default: "ui", isIndex: "title" },
              })({ isIndex: index === 0 })}
            >
              {line}
            </Text>
          ))}
        </div>
      </div>
      {children}
    </div>
  );
};
